import BaseView from '../../../js/base-view';

// import elementSize from '../../../js/utils/element-size';

const SELECTOR_TOGGLE = '.filters-foldable-title';
const SELECTOR_CONTENT = '.sidebar__content';

export default class PageShopFilter extends BaseView {
	init() {
		// Sub elements
		this.refs = {
			content: this.el.querySelector(SELECTOR_CONTENT),
			items: null,
		};
		this.refs.items = Array.from(this.refs.content.children);

		// States
		this.state = {
			isExpanded: (this.el.getAttribute('aria-expanded') === 'true'),
		};

		// this.setMaxHeight();

		// Events
		this.on('click', SELECTOR_TOGGLE, this.toggle.bind(this));
		// this.on('resize', this.setMaxHeight.bind(this));
	}

	toggle() {
		this.state.isExpanded = !this.state.isExpanded;
		this.el.setAttribute('aria-expanded', this.state.isExpanded);
	}

	// setMaxHeight () {
	// 	const contentHeight = this.refs.items.reduce( (totalHeigh, child) => (totalHeigh + elementSize(child).height), 0 );
  //   this.refs.content.style.maxHeight = `${contentHeight}px`;
  // }
}
